export default "__VITE_ASSET__CIFs_UcJ__"